import type { TokenName} from '@shared/constants/wallets';
import { tokensInfo } from '@shared/constants/wallets';
import { concatCurrencyToAmount } from '@shared/helpers/web3/formatters/concatCurrencyToAmount';

import { formatReward } from '@ui/uikit/utils';

import { weiToNumber } from './numberToWei';

export type ParsedWeiAmount = {
  wei: bigint;
  value: number;
  formatted: string;
};

export type ParseWeiFormatOptions = {
  stableToDollar?: boolean;
  showPlusSign?: boolean;
};

type BaseProps = {
  wei?: bigint;
  formatOptions?: ParseWeiFormatOptions;
};

type TokenNameProps = BaseProps & {
  tokenName: TokenName;
  symbol?: never;
  decimals?: never;
};

type DecimalsProps = BaseProps & {
  tokenName?: never;
  symbol: string;
  decimals: number;
};

type ParseWeiProps = TokenNameProps | DecimalsProps;

function isParseWeiByTokenNameProps(
  props: TokenNameProps | DecimalsProps,
): props is TokenNameProps {
  return (props as TokenNameProps).tokenName !== undefined;
}

export const parseWei = (props: ParseWeiProps) => {
  const { decimals, symbol } = isParseWeiByTokenNameProps(props)
    ? tokensInfo[props.tokenName]
    : props;

  const resultWei = props.wei ?? BigInt(0);
  const value = weiToNumber(resultWei, decimals);

  return {
    wei: resultWei,
    value,
    formatted: concatCurrencyToAmount(formatReward(value), symbol, { ...props.formatOptions }),
  };
};
